
    <ng-container *ngIf="whitelabel">
      <nav class="navbar navbar-expand-lg navbar-dark bg-dark fixed-top">
        <div class="container">
          <a class="navbar-brand" href="/"><img src="{{whitelabel.logo}}" alt="{{whitelabel.title}}" class="pull-left"></a>
          <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarResponsive"
                  aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
          </button>
          <div class="collapse navbar-collapse" id="navbarResponsive">
            <ul class="navbar-nav ml-auto">
              <li class="nav-item">
                <a class="nav-link" href="/logout" routerLink="/logout"><i class="fas fa-door-open"></i> Log-out</a>
              </li>
            </ul>
          </div>
        </div>
      </nav>

      <div class="content-wrapper">
        <div class="container">

          <div class="row">
            <div class="col-sm-12 col-md-12"
                 *ngIf="!whitelabel.client_bookings_limit || whitelabel.client_bookings_limit > active_appointments">

              <mat-horizontal-stepper [linear]="true" #stepper>
                <mat-step [stepControl]="searchForm">
                  <ng-template matStepLabel>
                    <app-loading *ngIf="loading_calendars"></app-loading>
                    <span class="hide-on-small-and-down">Find available time slots</span>
                    <span class="hide-on-med-and-up">Start</span>
                  </ng-template>
                  <ng-container *ngIf="loading_calendars">
                    <h4>Page loading, please wait</h4>
                  </ng-container>
                  <form [formGroup]="searchForm" class="form" (ngSubmit)="onSearchTimeslots()" *ngIf="!loading_calendars">

                    <div *ngIf="whitelabel.ask_home_address && searchForm.contains('address_id')" style="width:400px;">
                      <div class="mb-3">
                        <div class="form-group-lg">
                          <mat-form-field style="width:100%">
                            <mat-label>{{whitelabel.ask_home_address_label}}</mat-label>
                            <mat-select formControlName="address_id">
                              <mat-option *ngFor="let a of addresses" [value]="a.id">
                                {{a.address}}, {{a.postcode}}, {{a.country}}
                              </mat-option>
                              <mat-option (click)="openNewAdress()"> - Add new address -</mat-option>
                            </mat-select>
                          </mat-form-field>
                        </div>
                      </div>
                    </div>

                    <div *ngIf="whitelabel.allow_consultant_selection && calendars.length > 1" class="mb-6">
                      <div class="form-group-lg">
                        <h4>{{whitelabel.consultant_label}}</h4>
                        <div class="row">
                          <div class="col-xs-12 col-md-6" *ngFor="let c of calendars">
                            <label
                              *ngIf="!searchForm.get('type').value || c._appointmentTypes.indexOf(searchForm.get('type').value) >= 0"><input
                              type="radio" formControlName="calendar" [value]="c.id" required> {{c.name}}</label>
                            <label *ngIf="searchForm.get('type').value && c._appointmentTypes.indexOf(searchForm.get('type').value) < 0"
                                   class="text-muted"><input type="radio" disabled> {{c.name}}</label>
                          </div>
                          <div class="col-xs-12 col-md-6">
                            <label style="font-style: italic;"><input type="radio" formControlName="calendar" [value]="0" required> * Any *</label>
                          </div>
                        </div>
                      </div>

                      <div class="form-group-lg mb-3" *ngIf="groupedAppointmentTypesLength > 1">
                        <h4>{{whitelabel.type_label}}</h4>
                        <div class="row">
                          <span class="col-xs-12 col-md-6" *ngFor="let t of groupedAppointmentTypes() | keys">
                            <label
                              *ngIf="!searchForm.get('calendar').value || groupedAppointmentTypes(t).group.indexOf(searchForm.get('calendar').value) >= 0 || groupedAppointmentTypes(t).group.indexOf('global') >= 0"><input
                              type="radio" formControlName="type" [value]="t" required> {{t}}</label>
                            <label
                              *ngIf="searchForm.get('calendar').value && groupedAppointmentTypes(t).group.indexOf(searchForm.get('calendar').value) < 0 && groupedAppointmentTypes(t).group.indexOf('global') < 0"
                              class="text-muted"><input type="radio" disabled> {{t}}</label>
                          </span>
                        </div>
                      </div>
                    </div>

                    <div *ngIf="!whitelabel.allow_consultant_selection || calendars.length < 2" class="mb-3">
                      <div class="form-group-lg" *ngIf="appointmentTypesLength > 1">
                        <mat-form-field>
                          <!--  placeholder="{{whitelabel.type_label}}" -->
                          <input type="text" matInput formControlName="type" [matAutocomplete]="auto" [placeholder]="whitelabel.type_label">
                        </mat-form-field>
                        <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
                          <mat-optgroup *ngFor="let group of appointmentTypeOptions | async" [label]="group.name">
                            <mat-option *ngFor="let option of group.items" [value]="option">{{option.description}}</mat-option>
                          </mat-optgroup>
                        </mat-autocomplete>
                      </div>
                    </div>

                    <div class="form-group-lg mb-3">
                      <mat-form-field>
                        <input matInput [matDatepicker]="from" formControlName="from" placeholder="When you are available from?"
                               (click)="from.open();" readonly>
                        <mat-datepicker-toggle matSuffix [for]="from"></mat-datepicker-toggle>
                        <mat-datepicker touchUi #from></mat-datepicker>
                      </mat-form-field>
                    </div>

                    <div class="form-group-lg">
                      <button [disabled]="searchForm.invalid" class="btn btn-primary" matStepperNext>Continue</button>
                      <span class="ml-2 mr-2"> or </span>
                      <button type="reset" class="btn btn-secondary btn-sm">Reset</button>
                    </div>
                  </form>
                </mat-step>

                <mat-step [stepControl]="bookingForm">
                  <ng-template matStepLabel>
                    <span class="hide-on-small-and-down">Select Available Time Slot</span>
                    <span class="hide-on-med-and-up">Select</span>
                  </ng-template>

                  <div class="mb-5" *ngIf="timeslots.searching">
                    <app-loading></app-loading>
                    Looking for available time slots, please wait...
                  </div>
                  <div class="mb-5" *ngIf="timeslots.searched && !timeslots.searching">
                    <div *ngIf="timeslots.total == 0" class="alert alert-warning">
                      <h4>Unfortunately, there were no available time slots.</h4>
                      <p *ngIf="whitelabel.allow_consultant_selection">Perhaps, try selecting a different consultant.</p>
                    </div>
                    <button mat-button matStepperPrevious class="btn btn-secondary btn-sm" *ngIf="timeslots.total == 0">Try a different
                      search
                    </button>
                    <div *ngIf="timeslots.total == 1">
                      <h4>Great, we found a time slot for you.</h4>
                      <form [formGroup]="bookingForm" class="form" (ngSubmit)="onBookAppointment()">
                        <b>{{timeslots.results[0].formatted.start}}<span
                          *ngIf="whitelabel.show_end_time"> -> {{timeslots.results[0].formatted.end}}</span>
                          ({{timeslots.results[0].timezone}})</b>

                        <div *ngIf="whitelabel.ask_email && bookingForm.contains('email')" style="width:400px;">
                          <h4 class="mt-3">Please provide some additional information</h4>
                          <div *ngIf="whitelabel.ask_email && bookingForm.contains('email')" class="mb-3">
                            <div class="form-group-lg">
                              <mat-form-field>
                                <input type="email" matInput formControlName="email" placeholder="Please confirm your E-mail Address" type="email" [matAutocomplete]="emails" autocomplete="off">
                                <mat-autocomplete #emails="matAutocomplete">
                                  <mat-option *ngFor="let option of filteredEmails | async" [value]="option">
                                    {{option}}
                                  </mat-option>
                                </mat-autocomplete>
                                <mat-error *ngIf="bookingForm.controls['email'].errors?.email">
                                  <mat-icon inline>warning</mat-icon>
                                  Invalid Email Address
                                </mat-error>
                                <mat-error *ngIf="bookingForm.controls['email'].errors?.required">
                                  <mat-icon inline>warning</mat-icon>
                                  Please enter valid Email Address
                                </mat-error>
                              </mat-form-field>
                            </div>
                          </div>
                        </div>

                        <div class="form-group-lg mt-3">
                          <button [disabled]="bookingForm.invalid || booked" class="btn btn-primary" matStepperNext>Book this appointment
                          </button>
                          <span class="ml-2 mr-2"> or </span>
                          <button mat-button matStepperPrevious class="btn btn-secondary btn-sm">Start over</button>
                        </div>
                      </form>
                    </div>
                    <div *ngIf="timeslots.total > 1">
                      <h4>Great, we found {{timeslots.total}} available time slots for you. Please select the one you would like
                        to book.</h4>
                      <p>Note: All times are in {{timeslots.results[0].timezone}} timezone</p>
                      <form [formGroup]="bookingForm" class="form" (ngSubmit)="onBookAppointment()">
                        <div class="radio mt-1" *ngFor="let ts of timeslots.results">
                          <label><input type="radio" formControlName="timeslot" [value]="ts" required> {{ts.formatted.start}}<span
                            *ngIf="whitelabel.show_end_time"> ->
                            {{ts.formatted.end}}</span></label>
                        </div>

                        <div *ngIf="whitelabel.ask_email && bookingForm.contains('email')" style="width:400px;">
                          <h4>Please provide some additional information</h4>
                          <div *ngIf="whitelabel.ask_email && bookingForm.contains('email')" class="mb-3">
                            <div class="form-group-lg">
                              <mat-form-field>
                                <input matInput formControlName="email" placeholder="Please confirm your E-mail Address" type="email">
                              </mat-form-field>
                            </div>
                          </div>
                        </div>

                        <div class="form-group-lg mt-3">
                          <button [disabled]="bookingForm.invalid || booked" class="btn btn-primary" matStepperNext>Book the selected
                            appointment
                          </button>
                          <span class="ml-2 mr-2"> or </span>
                          <button mat-button matStepperPrevious class="btn btn-secondary btn-sm">Start over</button>
                        </div>
                      </form>
                    </div>
                  </div>

                </mat-step>

                <mat-step>
                  <ng-template matStepLabel>Done</ng-template>
                  <div class="row">
                    <div class="col-sm-12 col-md-9">
                      <alert></alert>
                    </div>
                    <div class="col-sm-12 col-md-3" style="height:150px;">
                      <p><span class="btn-group btn-block" *ngIf="showAddToCalendar">
                    <button type="button" class="btn btn-primary btn-block dropdown-toggle" data-toggle="dropdown" aria-haspopup="true"
                            aria-expanded="false">
                      Add to Calendar
                    </button>
                    <ul class="dropdown-menu">
                      <li><a [href]="recentlyBookedEvent.google" target="_blank">Google Calendar</a></li>
                      <li><a [href]="recentlyBookedEvent.ics" download>iCal</a></li>
                      <li><a [href]="recentlyBookedEvent.ics" download>Outlook</a></li>
                      <li><a [href]="recentlyBookedEvent.yahoo" target="_blank">Yahoo! Calendar</a></li>
                    </ul>
                  </span>
                      </p>
                      <p>
                        <button mat-button class="btn btn-secondary btn-block" (click)="stepper.reset()">Make another booking</button>
                      </p>
                    </div>
                  </div>
                </mat-step>
              </mat-horizontal-stepper>

            </div>
          </div>

          <div class="row">
            <div class="col-sm-12 col-md-12">
              <hr/>

              <div *ngIf="total_appointments > 0">
                <h3>Your appointments</h3>
                <div *ngFor="let g of appointments | keys " class="mt-3">
                  <div *ngIf="g!='CANCELED'">
                    <hr/>
                    <h5 class="text-capitalize">{{g|lowercase}}</h5>
                    <table class="table table-hover" *ngIf="g!='CANCELED'">
                      <thead>
                      <tr>
                        <th width="20%">Date</th>
                        <th width="20%">Time</th>
                        <th>Description</th>
                        <th></th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr *ngFor="let a of appointments[g]">
                        <td>{{a.start | date : "EEEE, d MMM"}}</td>
                        <td>{{a.start | date : "shortTime"}}</td>
                        <td>{{a.appointment_type.name}}</td>
                        <td class="text-right">
                          <div class="btn-group">
                         <span class="btn-group" *ngIf="a.allowed_operations.indexOf('cancel') >= 0">
                          <button type="button" class="btn btn-primary btn-block dropdown-toggle" data-toggle="dropdown"
                                  aria-haspopup="true" aria-expanded="false">
                            <span class="hide-on-med-and-down">Add to Calendar</span>
                            <span class="hide-on-large-only"><i class="fa fa-calendar-plus"></i></span>
                          </button>
                          <ul class="dropdown-menu">
                            <li><a [href]="a.google" target="_blank">Google Calendar</a></li>
                            <li><a [href]="a.ics" download>iCal</a></li>
                            <li><a [href]="a.ics" download>Outlook</a></li>
                            <li><a [href]="a.yahoo" target="_blank">Yahoo! Calendar</a></li>
                          </ul>
                        </span>
                            <button type="button" *ngIf="a.allowed_operations.indexOf('confirm') >= 0"
                                    class="btn btn-sm btn-info"
                                    (click)="confirmAppointment(a)">
                              <span class="hide-on-med-and-down">Confirm</span>
                              <span class="hide-on-large-only"><i class="fa fa-check"></i></span>
                            </button>
                            <button type="button" *ngIf="a.allowed_operations.indexOf('cancel') >= 0"
                                    class="btn btn-sm btn-danger" (click)="cancelAppointment(a)">
                              <span class="hide-on-med-and-down">Cancel</span>
                              <span class="hide-on-large-only"><i class="fa fa-ban"></i></span>
                            </button>
                          </div>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

                <div *ngIf="appointments['CANCELED']">
                  <button class="btn btn-link" type="button" data-toggle="collapse" data-target="#collapseExample"
                          aria-expanded="false" aria-controls="collapseExample">
                    Show cancelled bookings
                  </button>
                  <div class="collapse" id="collapseExample">
                    <table class="table table-hover">
                      <thead>
                      <tr>
                        <th width="20%">Date</th>
                        <th width="20%">Time</th>
                        <th>Description</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr *ngFor="let a of appointments['CANCELED']">
                        <td>{{a.start | date : "EEEE, d MMM"}}</td>
                        <td>{{a.start | date : "shortTime"}}</td>
                        <td>{{a.appointment_type.name}}</td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div class="help-block" *ngIf="!appointments">You don't have upcoming appointments for now.</div>
            </div>
          </div>
          <br/>
          <div class="row" *ngIf="whitelabel.page_footer">
            <div class="col-12 mt-lg" [innerHTML]="page_footer()"></div>
          </div>
        </div>
      </div>
    </ng-container>
  